import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useCalculateTextWidth } from "@/utils/calculateTextWidth";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";

interface Props {
    value: string,
    isBackground?: boolean,
    color?: 'text' | 'grey' | 'red' | 'green',
    font?: 'Inter' | 'Amiko',
    isClamp?: boolean,
    clamp?: number
    template?: (value: string) => string
    symbol?: string
    icon?: SVGElement
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemText',
  props: {
    value: null,
    isBackground: { type: Boolean },
    color: { default: 'text' },
    font: { default: 'Inter' },
    isClamp: { type: Boolean, default: true },
    clamp: { default: 1 },
    template: null,
    symbol: null,
    icon: null
  },
  setup(__props: any) {

const props = __props as { value: string, isBackground?: boolean, color: 'text' | 'grey' | 'red' | 'green', font: 'Inter' | 'Amiko', isClamp: boolean, clamp: number, template?: (value: string) => string, symbol?: string, icon?: SVGElement }




const fonts = {
    Inter: 'Inter, sans-serif',
    Amiko: 'Amiko, sans-serif',
};

const getClasses = computed(() => {
    const classes = {
        [`--${props.color}`]: !!props.color,
        '--clamp': props.isClamp,
    };
    return Object.keys(classes).filter((key) => classes[key]).join(' ');
});

const getStyle = computed(() => {
    const clamp = props.isClamp ? `-webkit-line-clamp: ${props.clamp};` : '';
    const font = `font-family: ${fonts[props.font]};`;
    return `${clamp}; ${font}`;
});

const textRef = ref<HTMLSpanElement | null>(null);

const isDisableTooltip = computed(() => {
    return !props.isClamp || (props.isClamp && !isClamped());
});
const isClamped = () => {
    const text = props.template ? props.template(props.value) : props.value;
    const compWidth = textRef.value?.getBoundingClientRect().width!;
    const textWidth = useCalculateTextWidth(text, { font: 'Inter, sans-serif', fontSize: 14, letterSpacing: 0.14 });
    const diff = Math.ceil(textWidth) - Math.floor(compWidth);
    return !!diff && diff > 1;
};

return { __sfc: true,props, fonts, getClasses, getStyle, textRef, isDisableTooltip, isClamped, BaseTooltip }
}

})